// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".calendar-table__head{display:grid;grid-template-columns:repeat(7,minmax(0,1fr))}.calendar-table__head>div{color:var(--text-text-ternary);font-size:1.4rem;text-align:center;padding-top:1rem;padding-bottom:1rem;font-weight:700}.calendar-table__body{display:grid;grid-template-columns:repeat(7,minmax(0,1fr))}.calendar-table__body>div{border-top-width:1px;border-color:var(--line-primary)}", ""]);
// Exports
module.exports = exports;
